var _path, _g, _circle, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCorprateOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_26781_143517)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_26781_143517",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M44 0H0V44H44V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_26781_143517)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.9778 6.41895V22.9931H26.4884V27.0191H25.616V22.6577L23.5357 22.3222C23.3345 21.5841 23.0659 20.9132 22.6633 20.309L23.9383 18.5645L20.7172 15.3435L18.9056 16.6854C18.3018 16.3499 17.6306 16.0816 16.9596 15.8801L16.6241 13.6658H12.0611L11.7257 15.8801C11.0547 16.0813 10.4506 16.3499 9.77963 16.6854L7.90075 15.2763L4.6797 18.4974L6.02162 20.309C5.68615 20.9128 5.41783 21.5841 5.21636 22.2551L3.00202 22.5905V27.0864L0.855469 27.0867V3.73486H5.95539L7.16328 6.48616H29.9781L29.9778 6.41895Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.0642 10.3115L30.7156 23.0609L30.6484 23.128V10.3118L33.0642 10.3115Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.1181 25.6772H29.1738V41.1107H41.1181V25.6772ZM35.3473 39.3661H30.4489V38.6952H35.3473V39.3661ZM39.9102 37.0847H30.4486V36.4137H39.9102V37.0847ZM39.9102 34.8032H30.4486V34.1322H39.9102V34.8032ZM39.9102 32.5217H30.4486V31.8507H39.9102V32.5217ZM39.9102 30.2402H30.4486V29.5693H39.9102V30.2402ZM39.9102 28.093H33.267V27.4221H39.9102V28.093Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.2266 23.7314V43.124H43.1301V23.7314H27.2266ZM41.7881 41.782H28.5018V25.0066H41.7881V41.782Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.9028 0.916504C27.4266 0.916504 26.2188 2.12439 26.2188 3.60059C26.2188 5.07679 27.4266 6.28467 28.9028 6.28467C30.379 6.28467 31.587 5.07679 31.587 3.60059C31.587 2.05725 30.379 0.916504 28.9028 0.916504ZM28.7013 4.74133L27.4263 3.66773L27.8962 3.13078L28.7015 3.80173L29.9764 2.45981L30.4463 2.9296L28.7013 4.74133Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2857 16.4175C34.8095 16.4175 33.6016 17.6254 33.6016 19.1016C33.6016 20.5778 34.8095 21.7857 36.2857 21.7857C37.7619 21.7857 38.9697 20.5778 38.9697 19.1016C38.9697 17.6251 37.7622 16.4175 36.2857 16.4175ZM37.4935 19.4371H36.6883V20.2424H36.0173V19.4371H35.2121V18.7662H36.0173V17.9609H36.6883V18.7662H37.4935V19.4371Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.0298 5.3457C36.5536 5.3457 35.3457 6.55358 35.3457 8.02978C35.3457 9.50598 36.5536 10.7138 38.0298 10.7138C39.506 10.7138 40.7139 9.50598 40.7139 8.02978C40.6467 6.55358 39.506 5.3457 38.0298 5.3457ZM39.1705 8.36532H38.3653V9.17059H37.6943V8.36532H36.889V7.69437H37.6943V6.88911H38.3653V7.69437H39.1705V8.36532Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.999 22.9264C22.7978 21.9869 22.3952 21.0475 21.8582 20.2423L23.0661 18.5646L20.6506 16.216L18.9729 17.4239C18.1676 16.8869 17.2952 16.5515 16.356 16.3503L16.0205 14.27H12.5983L12.2628 16.3503C11.3232 16.5515 10.5183 16.8872 9.71299 17.4239L7.96847 16.1489L5.55271 18.5646L6.82773 20.2423C6.29079 21.0476 5.95531 21.8529 5.75413 22.7921L3.67383 23.1276V26.5498L5.68699 26.8853C5.88815 27.8249 6.22394 28.7642 6.76059 29.5694L5.55271 31.18L7.96847 33.5957L9.51181 32.455C10.3842 32.9919 11.2563 33.3945 12.2631 33.6629L12.5314 35.6089L15.9533 35.6086L16.2217 33.7297C17.2281 33.5285 18.1677 33.1259 19.0401 32.5889L20.5834 33.7297L22.9992 31.3139L21.8585 29.7706C22.3954 28.8982 22.798 27.9589 22.9992 27.0193L24.9452 26.751V23.3287L22.999 22.9264ZM14.3432 31.3141C10.7867 31.3141 7.90137 28.4289 7.90137 24.8723C7.90137 21.3158 10.7866 18.4304 14.3432 18.4304C17.8997 18.4304 20.7851 21.3157 20.7851 24.8723C20.7851 28.4288 17.8998 31.3141 14.3432 31.3141Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5957 37.689V41.6479L26.2194 39.6351L22.5957 37.689Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.49805 41.7822H21.9251V37.5547H7.49805V41.7822Z",
    fill: "#B8170D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82759 37.5547H5.21702C4.07628 37.5547 3.13672 38.4943 3.13672 39.635C3.13672 40.7758 4.07628 41.7153 5.21702 41.7153H6.82759V37.5547Z",
    fill: "#B8170D"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 14.5,
    cy: 25,
    r: 5,
    fill: "#B8170D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_26781_143517"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorprateOn);
export default __webpack_public_path__ + "static/media/corprateOn.fce7e8edaeec462a7960fb70dabe451a.svg";
export { ForwardRef as ReactComponent };